export default __webpack_public_path__ + "static/media/transaction-submitted.b1b7c62e.png";